import { Directive, Inject, Input, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeepKeyOf } from '@x/common/utils';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';

type ShopConfigPath = DeepKeyOf<IShopConfig> | string;

interface IfShopConfigContext<T = any> {
  $implicit: T;
  xIfShopConfig: T;
}

@Directive({
  selector: '[xIfShopConfig]',
  standalone: true,
})
export class IfShopConfigDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<IfShopConfigContext>,
    private viewContainer: ViewContainerRef,
    @Optional() @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
  ) {}

  @Input() set xIfShopConfig(attributePath: ShopConfigPath) {
    const result = this.getConfigAttribute(attributePath);

    if (result.exists && !this.hasView) {
      const context: IfShopConfigContext = {
        $implicit: result.value,
        xIfShopConfig: result.value,
      };
      this.viewContainer.createEmbeddedView(this.templateRef, context);
      this.hasView = true;
    } else if (!result.exists && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private getConfigAttribute(attributePath: string): { exists: boolean; value: any } {
    if (!this.shopConfig || !attributePath) {
      return { exists: false, value: undefined };
    }

    const pathParts = attributePath.split('.');
    let current: any = this.shopConfig;

    for (const part of pathParts) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return { exists: false, value: undefined };
      }
    }

    return { exists: true, value: current };
  }
}
